export default __webpack_public_path__ + "assets/83595576af56dace0e45e4ee11e19bcf.jpg";